module.exports = __webpack_public_path__ + "img/02_L2.8c4cd62d.svg";